import { Box, Tooltip } from "@chakra-ui/react";
import { Info } from "lucide-react";

interface HelpTooltipProps {
    /** The tooltip's content, explaining the field or feature. */
    content: React.ReactNode;
    /** The aria-label for the tooltip trigger. */
    ariaLabel?: string;
}

export function HelpTooltip({ content, ariaLabel }: HelpTooltipProps) {
    return (
        <Tooltip.Root openDelay={200} positioning={{placement: 'top'}}>
            <Tooltip.Trigger asChild>
                <Box
                    as="span"
                    display="inline-flex"
                    color="gray.500"
                    cursor="help"
                    tabIndex={0}
                    aria-label={ariaLabel ?? 'Segítség'}
                >
                    <Info size={16}/>
                </Box>
            </Tooltip.Trigger>
            {/* Not portalled, like the calendar, so it stays inside the dialog. */}
            <Tooltip.Positioner>
                <Tooltip.Content>
                    {content}
                </Tooltip.Content>
            </Tooltip.Positioner>
        </Tooltip.Root>
    );
}